module.exports = __webpack_public_path__ + "static/img/0765.eb8dcdb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0765.jpg
// module id = 104
// module chunks = 0